import script from "./StoresIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoresIndex.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__